export default __webpack_public_path__ + "static/media/7d07efbb80dc3ad37a85c239f699422d.0cbabe97.jpg";